module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-RI.c2b3d189.png";